import { JobsXingletWrapper } from '../../../jobs-xinglet';
import { JobsRecommendationsSkeletons } from '../shared-components/skeletons';

export const SimilarJobs = JobsXingletWrapper(
  '@xing-com/crate-jobs-domain-recommendations-similar-jobs',
  <JobsRecommendationsSkeletons dataTestId="similar-jobs-skeleton" />
);
